<template>
  <section class="sac-step sac-step--2" v-if="model.etapaAtiva == 2">
    <div class="wrapper">
      <form class="form form-grid" @submit.stop.prevent="handlePersonalEdit" novalidate>
        <h3 class="form-sec-title col--wide">{{ _e('sac_title3_label') }}</h3>
        <BaseInput
          :label="_e('sac_name_label')"
          :placeholder="_e('sac_name_placeholder')"
          required
          class="col--wide col--md-8"
          v-model="model.nome">
        </BaseInput>
        <BaseInput
          :label="_e('sac_cpf_label')"
          :placeholder="_e('sac_cpf_placeholder')"
          required
          class="col--wide col--md-4"
          v-model="model.cpf"
          mask="###.###.###-##">
        </BaseInput>
        <BaseInput
          type="email"
          :label="_e('sac_email_label')"
          :placeholder="_e('sac_email_placeholder')"
          required
          class="col--wide col--md-6 vue-email"
          v-model="model.email">
          <template #prefix>
            <Icons name="mail"></Icons>
          </template>
        </BaseInput>
        <BaseInput
          type="email"
          :label="_e('sac_email2_label')"
          :placeholder="_e('sac_email_placeholder')"
          required
          class="col--wide col--md-6 vue-email-conf"
          v-model="model.email_confirmation">
          <template #prefix>
            <Icons name="mail"></Icons>
          </template>
        </BaseInput>

        <BaseInput
          :label="_e('sac_phone_label')"
          :placeholder="_e('sac_phone_placeholder')"
          required
          class="col--wide col--md-6"
          v-model="model.telefone"
          :mask="['(##) #####-####', '(##) ####-####']">
          <template #prefix>
            <Icons name="phone"></Icons>
          </template>
        </BaseInput>
        <BaseInput
          :label="_e('sac_phone2_label')"
          :placeholder="_e('sac_phone_placeholder')"
          class="col--wide col--md-6"
          v-model="model.telefone2"
          :mask="['(##) #####-####', '(##) ####-####']">
          <template #prefix>
            <Icons name="phone"></Icons>
          </template>
        </BaseInput>

        <h3 class="form-sec-title col--wide">{{ _e('sac_title4_label') }}</h3>
        <BaseInput
          :label="_e('sac_cep_label')"
          :placeholder="_e('sac_cep_placeholder')"
          required
          class="col--wide col--md-3"
          v-model="model.cep"
          mask="#####-###">
        </BaseInput>
        <BaseInput
          :label="_e('sac_endereco_label')"
          :placeholder="_e('sac_endereco_placeholder')"
          required
          class="col--wide col--md-9"
          v-model="model.endereco">
        </BaseInput>
        <BaseInput
          :label="_e('sac_bairro_label')"
          :placeholder="_e('sac_bairro_placeholder')"
          required
          class="col--wide col--md-5"
          v-model="model.bairro">
        </BaseInput>
        <BaseInput
          :label="_e('sac_numero_label')"
          :placeholder="_e('sac_numero_placeholder')"
          required
          class="col--wide col--md-3"
          v-model="model.numero">
        </BaseInput>
        <BaseInput
          :label="_e('sac_complemento_label')"
          :placeholder="_e('sac_complemento_placeholder')"
          class="col--wide col--md-4"
          v-model="model.complemento">
        </BaseInput>
        <DropdownInput class="col--wide col--md-6" required
          @change="stateChangeHandle"
          :label="_e('sac_estado_label')"
          :placeholder="_e('sac_estado_placeholder', 'Selecione o Estado')"
          :options="cep.estados"
          v-model="model.estado">
        </DropdownInput>
        <DropdownInput class="col--wide col--md-6" required
          :label="_e('sac_cidade_label')"
          :placeholder="_e('sac_cidade_placeholder', 'Selecione a Cidade')"
          :placeholder-loading="_e('sac_dropdown_loading', 'Carregando...')"
          :options="cep.cidades"
          :options-loading="isCepLoading"
          v-model="model.cidade">
        </DropdownInput>

        <div class="sac-separator col--wide"></div>

        <div class="sac-actions">
          <button type="button" class="btn" @click.stop.prevent="model.irParaEtapa(1)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M13.15 5.91847L11.3109 4.53979C10.5943 5.70944 9.89257 6.73839 9.20568 7.62663C8.50383 8.50005 7.78699 9.2846 7.05514 9.98026C6.32329 10.6759 5.5391 11.3271 4.70258 11.9339L4.70266 12.0672C5.53997 12.6602 6.32501 13.305 7.05777 14.0016C7.79053 14.6982 8.50841 15.4911 9.21141 16.3803C9.89945 17.2546 10.6025 18.2845 11.3207 19.4699L13.158 18.0714C12.5446 17.1378 11.9164 16.3006 11.2733 15.5596C10.6302 14.8186 9.98711 14.1813 9.34412 13.6476C8.70113 13.0992 8.07315 12.6618 7.46019 12.3356C6.84722 11.9945 6.26421 11.7571 5.71116 11.6235L5.71165 12.3789C6.26453 12.2459 6.84723 12.0093 7.45976 11.669C8.07228 11.3288 8.69968 10.8923 9.34197 10.3595C9.98425 9.81185 10.6265 9.17537 11.2686 8.45002C11.9108 7.70986 12.5379 6.86602 13.15 5.91847ZM19.6319 10.8105L12.4807 10.8059C11.4645 10.8052 10.5454 10.8416 9.72343 10.9151C8.88656 10.9886 8.1319 11.0844 7.45945 11.2025L5.958 12.0013L7.4605 12.8021C8.13309 12.9063 8.88787 12.9956 9.72484 13.0702C10.5469 13.1448 11.466 13.1825 12.4823 13.1831L19.6335 13.1878L19.6319 10.8105Z" fill="currentColor"></path></svg>
            <span class="btn__label">{{ _e('sac_anterior') }}</span>
          </button>
          <button type="submit" class="btn btn--primary">
            <span class="btn__label">{{ _e('sac_proximo') }}</span>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.186 5.91847L13.0251 4.53979C13.7417 5.70944 14.4435 6.73839 15.1304 7.62663C15.8322 8.50005 16.5491 9.2846 17.2809 9.98026C18.0128 10.6759 18.7969 11.3271 19.6335 11.9339L19.6334 12.0672C18.7961 12.6602 18.011 13.305 17.2783 14.0016C16.5455 14.6982 15.8276 15.4911 15.1246 16.3803C14.4366 17.2546 13.7335 18.2845 13.0154 19.4699L11.178 18.0714C11.7914 17.1378 12.4196 16.3006 13.0628 15.5596C13.7059 14.8186 14.3489 14.1813 14.9919 13.6476C15.6349 13.0992 16.2629 12.6618 16.8758 12.3356C17.4888 11.9945 18.0718 11.7571 18.6249 11.6235L18.6244 12.3789C18.0715 12.2459 17.4888 12.0093 16.8763 11.669C16.2638 11.3288 15.6364 10.8923 14.9941 10.3595C14.3518 9.81185 13.7096 9.17537 13.0674 8.45002C12.4253 7.70986 11.7981 6.86602 11.186 5.91847ZM4.70413 10.8105L11.8553 10.8059C12.8716 10.8052 13.7907 10.8416 14.6126 10.9151C15.4495 10.9886 16.2041 11.0844 16.8766 11.2025L18.378 12.0013L16.8755 12.8021C16.2029 12.9063 15.4482 12.9956 14.6112 13.0702C13.7892 13.1448 12.87 13.1825 11.8538 13.1831L4.70258 13.1878L4.70413 10.8105Z" fill="currentColor"></path></svg>
          </button>
        </div>
      </form>
    </div>
  </section>
</template>
<script setup>
import { computed, ref } from 'vue';
import { _e } from '../../../helpers/l10n';
import { useSacStore } from '../../../store/SacStore';
import { useCepStore } from '../../../store/CepStore';

import DropdownInput from '../../form/inputs/DropdownInput.vue';
import BaseInput from '../../form/inputs/BaseInput.vue';
import Icons from '../../icons/Icons.vue';

const model = useSacStore();
const cep = useCepStore();

const isCepLoading = ref(false);

const stateChangeHandle = async ()=>{
  isCepLoading.value = true;
  if(model.estado) {
    await cep.loadCidades(model.estado);
  } else {
    model.cidade = '';
  }
  isCepLoading.value = false;
};

function checkEmailConfirmation(form) {
  //const inputEmail = form.querySelector('.vue-email input');
  const inputEmailConf = form.querySelector('.vue-email-conf input');

  if(model.email) {
    if(model.email != model.email_confirmation) {
      //inputEmail.setCustomValidity(_e('sac_emails_not_equal'));
      inputEmailConf.setCustomValidity(_e('sac_emails_not_equal'));
      return false;
    }
  }

  //inputEmail.setCustomValidity('');
  inputEmailConf.setCustomValidity('');
  return true;
}

function handlePersonalEdit(e) {
  const form = e.target;
  if(checkEmailConfirmation(form) && form.checkValidity()) {
    form.classList.remove('form--validated');

    //Passar para a etapa 3 (revisão dos dados)
    model.irParaEtapa(3);

  } else {
    form.reportValidity();
    form.classList.add('form--validated');
  }
}

</script>
